(ns ycweb.app.admin.wholesale.clientorders.clientorder.tabs.config.order
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.common :as co.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.common :as co.t.cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.forms :as forms]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.util.cell :as dt.cell]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.grid :as grid]
   [ycweb.components.tables :as tables]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.admin.wholesale.common.products]))

(def datasource-atom-path :client-order/order.item-list)

(def order-items-table-name :admin.wholesale/client-order.order.items.table)
(def order-items-editor-name :admin.wholesale/client-order.order.items.editor)

(def order-additional-charges-table-name :admin.wholesale/client-order.order.additional-charges-table)
(def order-additional-charges-editor-name :admin.wholesale/client-order.order.additional-charges.editor)

(defn brand-select-fn [app-atom _ _ value]
  (let [editor-atom (editor/editor-cursor app-atom order-items-editor-name)]
    (editor/editor-overlay app-atom :open)
    (swap! editor-atom update :form
      (fn [form]
        (->
          form
          (update :client-order-item/brand-id assoc :value (:brand/id value)))))
    (comms/send :admin.wholesale/client-order.brand-products {:brand/id (:brand/id value)})))

(defmethod comms/receive :admin.wholesale/client-order.brand-products [app-atom {:keys [options]}]
  (editor/editor-overlay app-atom :close)
  (editor/post-comms app-atom order-items-editor-name
    {:options {:client-order-item/variation-id (:variations options)}}))

(defn datatable-buttons [app-atom editor-key]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        tags (map :name (cmn/curact process-atom :tags))
        backorder? (some #{"Backorder"} tags)
        invoice (cmn/curact process-atom :invoice)
        override-client-order (cmn/curact action-atom :override-client-order)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        disabled?
        (or
          (= dear-sync :pull)
          (contains? #{"Cancelled" "Sent to Courier" "Delivered"} (:client-order/status client-order))
          (contains? #{"Authorised" "Paid"} (:invoice/status invoice))
          (and
            (not override-client-order)
            (or
              (= (:client-order/status client-order) "Ready to Ship")
              (and (= (:client-order/status client-order) "Order Placed") (not backorder?)))))

        import-csv-cfg
        (yuc/maybe assoc
          {:text "CSV"
           :disabled disabled?
           :component-fn :import-fn}
          :action (when (= dear-sync :pull) :admin.wholesale/wholesale.editor-disabled)
          :config
          (when (= dear-sync :pull)
            {:title "Unable to import items"
             :msg "The order has been confirmed, unable to import line items"}))

        split-order-cfg
        (when (cmn/has-permission? app-atom co.cmn/back-order-permission)
          (merge
            {:text "Split Order"
             :attr {:small true}}
            (cond
              (and
                backorder?
                (= (:client-order/status client-order) "Ready to Ship"))
              {:action :admin.wholesale/client-order.split-order-modal
               :extends :remove
               :multi-select true}

              :else
              {:action :admin.wholesale/wholesale.editor-disabled
               :config
               {:title "Unable to Split Order"
                :msg "This feature is only available for backorders"}})))


        export-csv-cfg
        (yuc/maybe assoc
          {:text "CSV"
           :component-fn :export-fn})]

    [(yuc/maybe assoc
       {:text "Add"
        :title "Add an Item"
        :editor editor-key
        :extends :create
        :disabled disabled?
        :attr {:small true}
        :config {:text "Add"}}
       :description
       (when (and (not backorder?) override-client-order (= (:client-order/status client-order) "Order Placed"))
         (feedback/feedback :warning
           "Items added with not enough 'Available Stock' will force the order into 'Backorder'"
           "" nil "" :small)))
     (yuc/maybe assoc
       {:text "Update"
        :title "Update an Item"
        :editor editor-key
        :extends :edit
        :disabled disabled?
        :attr {:small true}
        :config {:text "Update"}}
       :description
       (when (and (not backorder?) override-client-order (= (:client-order/status client-order) "Order Placed"))
         (feedback/feedback :warning
           "Items added with not enough 'Available Stock' will force the order into 'Backorder'"
           "" nil "" :small)))
     {:text "Remove"
      :editor editor-key
      :extends :remove
      :multi-select true
      :disabled disabled?
      :attr {:small true}}
     (when (= editor-key :admin.wholesale/client-order.order.items.editor) import-csv-cfg)
     (when (= editor-key :admin.wholesale/client-order.order.items.editor) export-csv-cfg)
     (when (= editor-key :admin.wholesale/client-order.order.items.editor) split-order-cfg)]))

(defn reset-order-table-buttons [app-atom]
  (let [order-items-buttons (datatable-buttons app-atom order-items-editor-name)
        additional-charges-buttons (datatable-buttons app-atom order-additional-charges-editor-name)]
    (datatables/update-config app-atom order-items-table-name
      {:buttons order-items-buttons})
    (datatables/update-config app-atom order-additional-charges-table-name
      {:buttons additional-charges-buttons})))

(rum/defc status-indicator < rum/reactive [app-atom row]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)

        vid (:client-order-item/variation-id row)
        stock-detail (cmn/curact action-atom [:client-order/stock-details :variation/details vid])

        ready? (>= (:client-order-item/freestock row 0) (:client-order-item/qty row 0))
        not-ready (< (:client-order-item/freestock row 0) (:client-order-item/qty row 0))

        status
        (cond
          (= (:client-order/status client-order) "Cancelled")
          "Cancelled"

          (nil? stock-detail)
          "Loading"

          (not (contains? #{"Abandoned Cart" "Order Placed"} (:client-order/status client-order)))
          "Ordered"

          not-ready
          "Error"

          (not (pos? (:client-order-item/margin row)))
          "Warning"

          ready?
          "Ready")]

    [:div
     (cond
       (= status "Loading")
       [:i.u-animate-spin {:class (yuc/bem :icon [:2-1 :loading :inline])}]

       :else
       [:a
        {:on-click
         #(grid/open-modal app-atom :admin.wholesale/variation-stock-info
            {:details stock-detail
             :error
             (when not-ready
               {:title "Stock Issues"
                :message
                (str
                  "The ordered quantity (" (:client-order-item/qty row 0) ") is greater"
                  " than the stock quantity currently available (" (:client-order-item/freestock row 0) ")")})
             :warning
             (when (= status "Warning")
               {:title "Margin Issues"
                :message
                (str
                  "This product does not have a positive margin (" (:client-order-item/margin row) "%).
                   Selling would result in a loss.")})})
         :class
         (yuc/bem
           :admin-status-dot
           [:l
            (case status
              "Error"
              :error

              "Warning"
              :warning

              "Ready"
              :ready

              "Ordered"
              :ordered

              "Cancelled"
              :dark-grey)])}])
     [:p "Details"]]))

(defn weber-packbox-overview [app-atom _ _ v]
  (let [weber-permission? (cmn/has-any-permission? app-atom #{"SiteAdmin:Teams:Development"})
        packbox-id (str/replace v "PB-" "")
        dev-mode? (:dev-mode? (rum/react app-atom))
        packbox-url
        (str
          "https://weber." (when dev-mode? "dev.")
          "yuppiechef.com/admin/swad/inspect/" packbox-id)]
    (cond
      weber-permission?
      [:a
       {:href packbox-url}
       (str v)]

      :else
      [:a
       (urlstate/href-on-click #(toaster/open-toast app-atom :error "Incorrect permissions" {}))
       (str v)])))

(defn freestock-render
  "On a backorder show what Weber has set aside, which is what Authorise checks."
  [_app-atom row _col v]
  (let [{:client-order-item/keys [allocated-qty qty]} row]
    (cond
      (some? allocated-qty)
      (str allocated-qty " of " qty " allocated")

      :else
      v)))

(defn normalise-client-order-data [_ row _ _]
  (let [{:client-order-item/keys [qty discount price]
         :or {qty 0 discount 0 price 0}} row]
    {:qty qty
     :discount discount
     :price price}))

(defn editor-open-event [app-atom editor-atom mode]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)

        {:keys [field-idx-lookup editor-name]} @editor-atom
        price-field-idx (int (get field-idx-lookup :client-order-item/price))

        price-override-permission
        (cmn/has-any-permission? app-atom
          ["SiteAdmin:Teams:Development"
           co.cmn/manager-permission
           co.cmn/override-price-permission])]

    (when (not= mode :remove)
      (swap! app-atom update-in (conj editor/editor-cursor-prefix editor-name)
        (fn [editor-config]
          (->
            editor-config
            (update-in [:fields price-field-idx]
              (fn [input-field]
                (->
                  input-field
                  (update :attr assoc :disabled true)
                  (assoc
                    :label
                    [:div
                     [:span "Price"]
                     (when price-override-permission
                       [:div
                        [:span.action-button-slat__title.u-text-underline
                         {:on-click
                          #(grid/dispatch-action app-atom :admin.wholesale/clientorder.override-price
                             {:editor-name editor-name})
                          :style {:cursor "pointer"}}
                         "Enable Override Price"]])]))))
            (update :form
              (fn [form]
                (->
                  form
                  (update :client-order-item/client-order-id assoc :value (:client-order/id client-order))
                  (update :client-order-item/override-price assoc :value false))))))))))

(defn pre-submit-fn [app-atom _editor-atom _mode]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        tags (map :name (cmn/curact process-atom :tags))
        backorder? (some #{"Backorder"} tags)
        override-client-order (cmn/curact action-atom :override-client-order)]

    {:client-order/id (:client-order/id client-order)
     :backordered backorder?
     :overridden override-client-order}))

(defn variation-select-fn [app-atom _input-atom cfg selected-option]
  (let [editor-atom (editor/editor-cursor app-atom (:editor-name cfg))
        idx-lookup (cmn/curact editor-atom :field-idx-lookup)
        idx (int (get idx-lookup :client-order-item/variation-id))
        formatted-price (yuc/number-format (trf/fromcurrency (:variation/price selected-option)) 2)]

    (swap! app-atom update-in (conj editor/editor-cursor-prefix (:editor-name cfg))
      (fn [editor-config]
        (->
          editor-config
          (update-in [:fields idx :attr] merge
            {:hint (str "Available stock = " (:variation/freestock selected-option))})
          (update :form
            (fn [form]
              (->
                form
                (update :client-order-item/price assoc :value formatted-price)
                (update :client-order-item/variation-id assoc :value (:variation/id selected-option))))))))))

(def base-datatable-fns
  {:data-source-fns
   {:entity-fn (partial co.t.cmn/data-source-parameters)}
   :column-fns
   {:default-fn dt.cell/boolean-fn
    :price-fn co.t.cmn/price-render
    :currency-fn co.t.cmn/from-currency-fn
    :normalise-fn normalise-client-order-data
    :total-fn co.t.cmn/total-logic}})

(defn base-table-config [app-atom table-name column-defs & [editor-name]]
  (let [process-name (cmn/process-name app-atom)
        buttons (datatable-buttons app-atom editor-name)]
    {:table-name table-name
     :row-id :client-order-item/id
     :data-source
     {:cursor [process-name datasource-atom-path]
      :parameter-fn :entity-fn}
     :options
     {:order :asc
      :sort-title "Product"
      :filter :filter-rows}
     :select? {:style :os}
     :buttons buttons
     :column-defs
     column-defs}))

;;===============================================================================
;;                                 Order Config
;;===============================================================================

(rum/defc client-order-csv-field-errors-body < rum/reactive cmn/cursors [_ modal-atom _]
  (let [title (cmn/curact modal-atom :title)
        field-errors (cmn/curact modal-atom :field-errors)]
    [:div.u-min-height-160
     (tables/table
       title
       [{:key :original/product_sku :title "SKU"}
        {:key :client-order-item/client-order-id :title "Client Order"}
        {:key :client-order-item/variation-id :title "Variation"}
        {:key :client-order-item/qty :title "QTY"}
        {:key :client-order-item/price :title "Price"}
        {:key :client-order-item/discount :title "Discount"}]
       field-errors
       {:pagination? true
        :page-size 5})]))

(defmethod grid/modal-config :admin.wholesale/client-order.csv-import.field-errors [_ _ _]
  {:body client-order-csv-field-errors-body
   :footer grid/modal-message-footer
   :max-width 920})

(rum/defc csv-import-items < rum/reactive [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        session-id (cmn/curact app-atom :php-session-id)
        client-order (cmn/curact process-atom :client-order)
        invoice (cmn/curact process-atom :invoice)
        override-client-order (cmn/curact action-atom :override-client-order)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        disabled?
        (and
          (or
            (contains? #{"Cancelled" "Ready to Ship" "Sent to Courier" "Delivered"} (:client-order/status client-order))
            (contains? #{"Authorised" "Paid"} (:invoice/status invoice))
            (= dear-sync :pull))
          (not override-client-order))]
    [:div
     {:class (yuc/bem :flex-grid-block [:fluid])}
     (forms/raw-fileupload
       (rum/cursor action-atom :upload-csv-items)
       {:path (str "/api/admin/wholesale/client-order/" (:client-order/uuid client-order) "/csv/import")
        :name "order-upload"
        :allowed-types (yuc/get-allowed-types :csv)
        :data {:php-session-id session-id}
        :small? true
        :disabled? disabled?
        :status/messages
        {:uploaded "CSV"
         :error "Error, re-import CSV"
         :default "Import CSV"}
        :processing-fn
        (fn [_]
          (datatables/overlay app-atom :open order-items-table-name))
        :done-fn
        (fn [local-atom {:keys [success field-errors msg rows]}]
          (swap! local-atom assoc :status :default)
          (swap! action-atom assoc :upload-csv-items nil)
          (datatables/overlay app-atom :close order-items-table-name)
          (cond
            success
            (let [order-item-ids
                  (when success
                    (->>
                      rows
                      (filter #(not= (:variation/features %) "Service"))
                      (map :client-order-item/id)))]
              (toaster/open-toast app-atom :success msg {})
              (when success
                (comms/send :admin.wholesale/client-order.item-info
                  {:client-order/id (:client-order/id client-order)
                   :client-order-item/id order-item-ids})
                (datatables/add-rows app-atom order-items-table-name {:rows rows})))

            (and
              (not success)
              (yuc/presence field-errors))
            (grid/open-modal app-atom :admin.wholesale/client-order.csv-import.field-errors
              {:title "Field Errors"
               :field-errors field-errors})

            :else
            (grid/open-modal app-atom :grid/message
              {:title "Warning"
               :text
               (feedback/feedback (if success :info :warning)
                 [:p msg])})))
        :error-fn
        (fn [local-atom]
          (datatables/overlay app-atom :close order-items-table-name)
          (swap! local-atom assoc :status :error))})]))

(rum/defc csv-export-items < rum/reactive [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)]
    [:div
     {:class (yuc/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      [:form
       {:method "GET" :target "_blank"
        :name "client-order-csv-form"
        :action (str "/api/admin/wholesale/client-order/" (:client-order/uuid client-order) "/csv/export")}
       (buttons/button-web "Export CSV"
         {:type :submit
          :size :small
          :icon :download
          :style :secondary})]]]))

(def order-items-table-fns
  (yuc/deep-merge
    base-datatable-fns
    {:editor
     {:event-fns
      {:open-fn editor-open-event
       :pre-submit-fn pre-submit-fn}
      :form
      {:fields
       {:client-order-item/brand-id
        {:select-fn brand-select-fn}
        :client-order-item/variation-id
        {:select-fn variation-select-fn}}}}
     :column-fns
     {:status-fn
      (fn [app-atom row _ _]
        [:div.u-text-center
         (status-indicator app-atom row)])
      :product-fn co.t.cmn/product-render
      :freestock-fn freestock-render
      :weber-packbox-fn weber-packbox-overview}
     :button-fns
     {:export-fn (partial csv-export-items)
      :import-fn (partial csv-import-items)}
     :config-fns
     {:filter-rows
      (fn [_ client-order-items]
        (remove w.cmn/service-variation? client-order-items))}}))

(defn order-items-editor-config [app-atom]
  {:editor-name order-items-editor-name
   :datatable order-items-table-name
   :mode :read
   :end-points
   {:create :admin.wholesale/client-order.order.item.add
    :edit :admin.wholesale/client-order.order.item.edit
    :remove :admin.wholesale/client-order.order.item.remove}
   :fields
   [{:label "Brand:"
     :name :client-order-item/brand-id
     :type :select-search
     :attr
     {:placeholder "Search a brand to filter products by"
      :type :text}
     :opts-cfg {:lookup {:value :brand/id :text :brand/name}}}
    {:label "Product:"
     :name :client-order-item/variation-id
     :type :select-search
     :attr
     {:placeholder "Search for a Product"
      :type :text}
     :opts-cfg {:lookup {:value :variation/id :text :variation/fullname}}}
    {:label "Qty:"
     :name :client-order-item/qty}
    {:label "Discount:"
     :name :client-order-item/discount
     :attr {:default 0}}
    {:label "Price"
     :name :client-order-item/price
     :type :number
     :attr
     {:disabled true
      :type :currency}}
    {:label "Comments:"
     :name :client-order-item/comments}
    {:name :client-order-item/uuid
     :type :hidden}
    {:name :client-order-item/client-order-id
     :type :hidden}
    {:name :client-order-item/override-price
     :type :hidden
     :attr {:default false}}]})

(defmethod grid/action :admin.wholesale/clientorder.override-price [app-atom {:keys [editor-name]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        editor-atom (editor/editor-cursor app-atom editor-name)
        form-atom (rum/cursor editor-atom :form)
        override-price-input (cmn/curact form-atom :client-order-item/override-price)
        override-price (:value override-price-input)
        new-override-price-value (not override-price)
        enabled (true? new-override-price-value)

        idx-lookup (cmn/curact editor-atom :field-idx-lookup)
        price-field-idx (int (get idx-lookup :client-order-item/price))

        price-override-permission
        (cmn/has-any-permission? app-atom
          ["SiteAdmin:Teams:Development"
           co.cmn/manager-permission
           co.cmn/override-price-permission])]

    (grid/dispatch-action app-atom :admin.wholesale/log.change
      {:operation "action"
       :table-name "clientorder"
       :source "client_order_overview"
       :message (str (if enabled "Enabling" "Disabling") " price override")
       :parent-id (:client-order/id client-order)})

    (swap! app-atom update-in (conj editor/editor-cursor-prefix editor-name)
      (fn [editor-config]
        (->
          editor-config
          (update-in [:fields price-field-idx]
            (fn [input-field]
              (->
                input-field
                (update :attr assoc :disabled (not enabled))
                (assoc :label
                  [:div
                   [:span "Price"]
                   (when price-override-permission
                     [:div
                      [:span.action-button-slat__title.u-text-underline
                       {:on-click
                        #(grid/dispatch-action app-atom :admin.wholesale/clientorder.override-price
                           {:editor-name editor-name})
                        :style {:cursor "pointer"}}
                       (str (if enabled "Disable" "Enable") " Override Price")]])]))))
          (update-in [:form :client-order-item/override-price] assoc :value new-override-price-value))))))

(defmethod comms/receive :admin.wholesale/client-order.order.item.add
  [app-atom {:keys [rows msg backorder-response] :as e}]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        {:keys [success]} (editor/post-submit app-atom order-items-editor-name e)
        order-item-ids
        (when success
          (->>
            (:rows e)
            (filter #(not= (:variation/features %) "Service"))
            (map :client-order-item/id)))]

    (when (yuc/presence backorder-response)
      (swap! process-atom update :tags conj (:backorder-tag backorder-response))
      (grid/message-modal app-atom
        {:title "Order changed to Backordered"
         :text
         [:div
          (when (pos? (:zero-stock-count backorder-response))
            (co.t.cmn/format-stock-items app-atom (:zero-stock-items backorder-response) "Items with no stock:"))
          (when (pos? (:partial-stock-count backorder-response))
            (co.t.cmn/format-stock-items app-atom (:partial-stock-items backorder-response) "Items with partial stock:"))]
         :confirm-text "Acknowledge"}))
    (when success
      (comms/send :admin.wholesale/client-order.item-info
        {:client-order/id (:client-order/id client-order)
         :client-order-item/id order-item-ids})
      (datatables/add-rows app-atom order-items-table-name {:rows rows})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(defmethod comms/receive :admin.wholesale/client-order.order.item.edit
  [app-atom {:keys [client-order-items msg backorder-response] :as e}]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        {:keys [success]} (editor/post-submit app-atom order-items-editor-name e)
        order-item-ids
        (when success
          (->>
            (:rows e)
            (filter #(not= (:variation/features %) "Service"))
            (map :client-order-item/id)))]

    (when (yuc/presence backorder-response)
      (swap! process-atom update :tags conj (:backorder-tag backorder-response))
      (grid/message-modal app-atom
        {:title "Order changed to Backordered"
         :text
         [:div
          (when (pos? (:zero-stock-count backorder-response))
            (co.t.cmn/format-stock-items app-atom (:zero-stock-items backorder-response) "Items with no stock:"))
          (when (pos? (:partial-stock-count backorder-response))
            (co.t.cmn/format-stock-items app-atom (:partial-stock-items backorder-response) "Items with partial stock:"))]
         :confirm-text "Acknowledge"}))

    (when success
      (comms/send :admin.wholesale/client-order.item-info
        {:client-order/id (:client-order/id client-order)
         :client-order-item/id order-item-ids})
      (datatables/update-rows app-atom order-items-table-name {:rows client-order-items})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(defmethod comms/receive :admin.wholesale/client-order.order.item.remove
  [app-atom {:keys [client-order-item-ids msg] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom order-items-editor-name e)]
    (when success
      (datatables/remove-rows app-atom order-items-table-name {:row-ids client-order-item-ids})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(def order-items-column-defs
  [{:title "Stock"
    :key :client-order-item/id
    :render {:render-k :status-fn}
    :options {:ignore-row-click true}}
   {:title "Product"
    :key :variation/fullname
    :render {:logic-k :product-fn}}
   {:title "Qty Ordered"
    :key :client-order-item/qty
    :align-class :u-text-center}
   {:title "Qty Freestock"
    :key :client-order-item/freestock
    :align-class :u-text-center
    :render {:render-k :freestock-fn}}
   {:title "Price"
    :key :client-order-item/price
    :render
    {:logic-k :currency-fn
     :render-k :price-fn}}
   {:title "Discount (%)"
    :key :client-order-item/discount
    :type :number
    :align-class :u-text-center}
   {:title "Discount Price"
    :key :client-order-item/discounted-price
    :render
    {:logic-k :currency-fn
     :render-k :price-fn}}
   {:title "Margin"
    :key :client-order-item/margin
    :type :percentage}
   {:title "Total"
    :key :client-order-item/total
    :render
    {:logic-k :currency-fn
     :render-k :price-fn}}
   {:title "Comments"
    :key :client-order-item/comments}
   {:title "Location"
    :key :client-order-item/location}
   {:title "Packbox"
    :key :client-order-item/packbox
    :render
    {:render-k :weber-packbox-fn}}])

;;===============================================================================
;;                       Additional Items Config
;;===============================================================================

(def additional-charges-table-fns
  (yuc/deep-merge
    base-datatable-fns
    {:editor
     {:event-fns {:open-fn editor-open-event}}
     :config-fns
     {:filter-rows
      (fn [_ client-order-items]
        (filter w.cmn/service-variation? client-order-items))}}))

(def order-additional-charges-editor-config
  {:editor-name order-additional-charges-editor-name
   :datatable order-additional-charges-table-name
   :mode :read
   :end-points
   {:create :admin.wholesale/client-order.order.additional-charge.add
    :edit :admin.wholesale/client-order.order.additional-charge.edit
    :remove :admin.wholesale/client-order.order.additional-charge.remove}
   :fields
   [{:label "Product:"
     :name :client-order-item/variation-id
     :type :select-search
     :attr
     {:placeholder "Search for a Product"
      :type :text}
     :opts-cfg {:lookup {:value :variation/id :text :variation/fullname}}}
    {:label "Qty:"
     :name :client-order-item/qty
     :type :number
     :attr {:disabled true :default 1}}
    {:label "Price"
     :name :client-order-item/price
     :type :number}
    {:label "Comments:"
     :name :client-order-item/comments}
    {:name :client-order-item/uuid
     :type :hidden}
    {:name :client-order-item/client-order-id
     :type :hidden}]})

(defmethod comms/receive :admin.wholesale/client-order.order.additional-charge.add
  [app-atom {:keys [rows msg] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom order-additional-charges-editor-name e)]
    (when success
      (datatables/add-rows app-atom order-additional-charges-table-name {:rows rows})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(defmethod comms/receive :admin.wholesale/client-order.order.additional-charge.edit
  [app-atom {:keys [client-order-items msg] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom order-additional-charges-editor-name e)]
    (when success
      (datatables/update-rows app-atom order-additional-charges-table-name {:rows client-order-items})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(defmethod comms/receive :admin.wholesale/client-order.order.additional-charge.remove
  [app-atom {:keys [client-order-item-ids msg] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom order-additional-charges-editor-name e)]
    (when success
      (datatables/remove-rows app-atom order-items-table-name {:row-ids client-order-item-ids})
      (toaster/open-toast app-atom :success msg {:closetime 3000}))))

(def order-additional-charges-column-defs
  [{:title "Description"
    :key :variation/name
    :render {:render-k :product-fn}}
   {:title "Qty"
    :key :client-order-item/qty
    :align-class :u-text-center}
   {:title "Price"
    :key :client-order-item/price
    :render
    {:logic-k :currency-fn
     :render-k :price-fn}}
   {:title "Total"
    :key :client-order-item/total
    :render
    {:logic-k :currency-fn
     :render-k :price-fn}}])

(defn order-items-table-config [app-atom]
  (base-table-config app-atom
    order-items-table-name
    order-items-column-defs
    order-items-editor-name))

(defn additional-charges-table-config [app-atom]
  (base-table-config app-atom
    order-additional-charges-table-name
    order-additional-charges-column-defs
    order-additional-charges-editor-name))

;;===============================================================================
;;                                 Split Order
;;===============================================================================

(rum/defc modal-new-split-order-footer < rum/reactive [app-atom]
  (let  [modal-atom (grid/modal-cursor app-atom)
         {:keys [client-order]} (cmn/curact modal-atom :config)]
   (grid/button-row
     {:left-text "Cancel"
      :left-fn #(grid/close-modal app-atom)
      :left-no-icon true
      :right-text (str "View SO-" (:refid client-order))
      :right-fn #(urlstate/href-props app-atom "wholesale" "client_order_overview" {:uuid (:uuid client-order)})
      :right-no-icon true})))

(rum/defc modal-new-split-order-body < rum/reactive [app-atom]
  (let [modal-atom (grid/modal-cursor app-atom)
        {:keys [title client-order updated-rows deleted-rows]} (cmn/curact modal-atom :config)]
    [:div
     [:div.section
      [:div.u-margin-top-24
       [:h1 {:class (yuc/bem :heading [:standard])} title]]]
     [:div.section
      [:div.u-margin-top-24
       [:p (str "A new order (SO-" (:refid client-order) ") has successfully been split.")]
       [:p "Please allow some time for the allocation of stock to readjust,
            this should take between 10-20 minutes"]
       [:hr]
       [:p "The current order had the following changes"
        [:ol
         [:li (count updated-rows) " rows updated, adjusting their quantities"]
         [:li (count deleted-rows) " rows removed, as the ordered quantity hit zero"]]]]]]))

(defmethod grid/modal-config :admin.wholesale/client-order.new-split-order [_app-atom config-atom _]
  (let [{:keys [title client-order updated-rows deleted-rows]} @config-atom]
    {:body modal-new-split-order-body
     :footer modal-new-split-order-footer
     :title title
     :client-order client-order
     :updated-rows updated-rows
     :deleted-rows deleted-rows}))

(defmethod comms/receive :admin.wholesale/client-order.split-order [app-atom e]
  (cond
    (yuc/presence (:overlay-msg e))
    (datatables/overlay app-atom (:overlay-msg e) order-items-table-name)

    :else
    (let [client-order (:new-client-order e)]
      (toaster/open-toast app-atom :success "Order split" {})
      (grid/open-modal app-atom :admin.wholesale/client-order.new-split-order
        {:title (str "New Split Order: SO-" (:refid client-order))
         :client-order client-order
         :updated-rows (:updated-rows e)
         :deleted-rows (:deleted-row-ids e)})
      (datatables/update-rows app-atom order-items-table-name {:rows (:updated-rows e)})
      (datatables/remove-rows app-atom order-items-table-name {:row-ids (:deleted-row-ids e)})
      (datatables/overlay app-atom :close order-items-table-name))))

(defmethod grid/action :admin.wholesale/client-order.split-order [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        kv-rows
        (->>
          (get-in config [:table-config :rows])
          (vals)
          (reduce
            (fn [acc i]
              (assoc acc
               (:client-order-item/variation-id i)
                (:client-order/split-qty i)))
            {}))]

    (comms/send :admin.wholesale/client-order.split-order
      {:client-order/uuid (:client-order/uuid client-order)
       :client-order-item/id (:selected-row-ids config)
       :split-order-items kv-rows})

    (datatables/overlay app-atom :open order-items-table-name)))

(rum/defc modal-split-order-footer < rum/reactive [app-atom modal-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-fn #(grid/close-modal app-atom)
     :left-no-icon true
     :right-text "Split"
     :right-fn #(grid/dispatch-modal-action app-atom :admin.wholesale/client-order.split-order)
     :right-no-icon true}))

(rum/defc modal-split-order-body < rum/reactive [app-atom]
  (let [modal-atom (grid/modal-cursor app-atom)
        {:keys [title description table-config]} (cmn/curact modal-atom :config)]
    [:div
     [:div.section
      [:div.u-margin-top-24
       [:h1 {:class (yuc/bem :heading [:standard])}
        title
        [:p description]]]]
     [:div.section
      (tables/table ""
        [{:title "Product" :key :variation/fullname}
         {:title "Ordered Qty" :key :client-order-item/qty :align-class :u-text-center}
         {:title "Allocated Qty" :key :client-order-item/allocated-qty}
         {:title "Split Qty" :key :client-order-item/variation-id
          :align-class :u-text-center
          :component-fn
          (fn [variation-id]
            (forms/input-raw ""
              (rum/cursor-in modal-atom [:config :table-config :rows variation-id :client-order/split-qty])
              {:type :number}))}]
        (vals (:rows table-config))
        {})]]))

(defmethod grid/modal-config :admin.wholesale/client-order.split-order [_app-atom config-atom _]
  (let [{:keys [title description table-config]} @config-atom]
    {:body modal-split-order-body
     :footer modal-split-order-footer
     :modal-type :xlarge
     :title title
     :description description
     :table-config table-config}))

(defmethod grid/action :admin.wholesale/client-order.split-order-modal [app-atom {:keys [selected-row-ids]} _]
  (let [selected-rows-gpd
        (->>
          selected-row-ids
          (datatables/rows app-atom order-items-table-name)
          (vals)
          (group-by :client-order-item/variation-id))

        rows
        (reduce
          (fn [acc [_ rows]]
            (let [row
                  (->
                    rows
                    (first)
                    (select-keys [:client-order-item/variation-id :variation/fullname]))
                  sum-qty (first (yuc/collapse-sum :client-order-item/variation-id :client-order-item/qty rows))
                  sum-allocs (first (yuc/collapse-sum :client-order-item/variation-id :client-order-item/allocated-qty rows))]
              (conj acc
                (assoc row
                  :client-order-item/qty (:client-order-item/qty sum-qty)
                  :client-order-item/allocated-qty (:client-order-item/allocated-qty sum-allocs)))))
          [] selected-rows-gpd)]

    (grid/open-modal app-atom :admin.wholesale/client-order.split-order
      {:title "Split Order"
       :selected-row-ids selected-row-ids
       :description
       "'Split Qty' -
        On the original order, the quantity will be reduced by the amount entered.
        If the quantity is zero, the SKU will be removed.
        This quantity will also be used to populate the new order's item line.
        If there are multiple rows of the same SKU selected. The lowest quantities will be moved across first."
       :table-config
       {:rows (yuc/index-by :client-order-item/variation-id rows)}})))